import React from 'react'
import Button from '../Button'
import { ReactComponent as Warning } from '../../assets/icons/modal/Warning.svg'

const SubmissionError = ({ onclickOpen, noCloseIcon, setIsErrorModalStyle, tryagainClick, setIsExportAll }) => {
  let inventoryAccountError
  let inventoryReportMap 
  const inventoryReportMapArr = window.location.href.split('/')
  inventoryReportMapArr.find(function(element, index){
    if(inventoryReportMapArr.length === 4 && (window.location.pathname === '/InventoryAccount')){
      inventoryAccountError = true
      inventoryReportMap =  false
    }
    else if((window.location.pathname === '/InventoryAccount/InventoryReferenceInfo') || window.location.pathname === '/InventoryAccount/InventoryReferenceInfo/InventoryReport' || window.location.pathname === '/InventoryAccount/InventoryReport'){
      inventoryAccountError = false
      inventoryReportMap =  true
    }
    return element
  })

  const handleClick = () => {
    onclickOpen(true)
    noCloseIcon(false)
    setIsErrorModalStyle(false)
    setIsExportAll && setIsExportAll(false)
    tryagainClick && tryagainClick()
  }

  const handleAccountList =() =>{
    onclickOpen(true)
    noCloseIcon(false)
    setIsErrorModalStyle(false)
    tryagainClick(true)
  }
  
  return (
    <>
      <div className="modal-warning-container" data-test="warning-container">
        <div className="modal-warning-icon" data-test="warning-icon">
          <Warning aria-label={'warning icon'} tabIndex="0"/>
        </div>
        <div className="modal-warning-greeting" aria-labelledby="warning-greeting-text" data-test="warning-greeting">
          <span id="warning-greeting-text" tabIndex="0">{inventoryReportMap ? "Oops! Export Failed" : "Uh oh!"}</span>
        </div>
        <div className="modal-warning-content" aria-labelledby="warning-content-text" data-test="warning-content">
          <span id="warning-content-text" tabIndex="0">Something went wrong. Please try again</span>
        </div>
        <div className="modal-warning-action" data-test="warning-button">
          <Button
            className={`-primary`}
            aria-label={`Try Again`}
            data-a11y-focus="first"
            onClick={inventoryAccountError ? handleAccountList :handleClick }
          >
            Try Again
          </Button>
        </div>
      </div>        
    </>
  )
}
export default SubmissionError